import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Page } from "../components/AppShell";
import CrudPanel from "../components/CrudPanel";

/**
 * GLBA Verifications — financial/identity verifications performed under the
 * Gramm-Leach-Bliley Act permissible-purpose framework.
 *
 * Logs each verification attempt against a Job + Subject, who requested it,
 * the permissible purpose claimed, when it was verified, and the response.
 */
export default function GLBA() {
  const [jobs, setJobs] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [users, setUsers] = useState([]);
  const [certTypes, setCertTypes] = useState([]);

  useEffect(() => {
    api.get("/jobs").then(r => setJobs(r.data)).catch(() => setJobs([]));
    api.get("/subjects").then(r => setSubjects(r.data)).catch(() => setSubjects([]));
    api.get("/users").then(r => setUsers(r.data)).catch(() => setUsers([]));
    api.get("/glba-certification-types").then(r => setCertTypes(r.data.filter(t => t.is_active !== false))).catch(() => setCertTypes([]));
  }, []);

  const jobLabel = (j) => j.job_number || j.id?.slice(0, 8) || "—";
  const subjLabel = (s) => [s.first_name, s.last_name].filter(Boolean).join(" ") || s.aka || s.id?.slice(0, 8);

  return (
    <Page
      title="GLBA Verifications"
      subtitle="GRAMM-LEACH-BLILEY PERMISSIBLE-PURPOSE LOG"
      breadcrumbs={[{ label: "Dashboard", to: "/" }, "GLBA"]}
      testid="glba-page"
    >
      <CrudPanel
        endpoint="/glba-verifications"
        testid="glba"
        columns={[
          { key: "job_id", label: "JOB", render: r => jobs.find(j => j.id === r.job_id)?.job_number || (r.job_id ? r.job_id.slice(0, 8) : "—") },
          { key: "subject_id", label: "SUBJECT", render: r => {
            const s = subjects.find(x => x.id === r.subject_id);
            return s ? subjLabel(s) : "—";
          }},
          { key: "certification_type_id", label: "CERT TYPE", render: r => r.certification_type_name || certTypes.find(t => t.id === r.certification_type_id)?.name || "—" },
          { key: "purpose", label: "PURPOSE" },
          { key: "requested_by_user_id", label: "REQUESTED BY", render: r => users.find(u => u.id === r.requested_by_user_id)?.name || "—" },
          { key: "verified_at", label: "VERIFIED AT", render: r => r.verified_at ? new Date(r.verified_at).toLocaleString() : "—" },
        ]}
        formFields={[
          { key: "job_id", label: "JOB", type: "select", options: jobs.map(j => ({ id: j.id, name: jobLabel(j) })) },
          { key: "subject_id", label: "SUBJECT", type: "select", options: subjects.map(s => ({ id: s.id, name: subjLabel(s) })) },
          { key: "certification_type_id", label: "CERTIFICATION TYPE", type: "select", options: certTypes.map(t => ({ id: t.id, name: t.name })) },
          { key: "purpose", label: "PERMISSIBLE PURPOSE (free text)" },
          { key: "verified_at", label: "VERIFIED AT", type: "datetime-local" },
          { key: "response_summary", label: "RESPONSE SUMMARY", type: "textarea" },
        ]}
      />
    </Page>
  );
}
